<template>
  <div class="exchangeRule">
    <h1>兑换规则</h1>
    <h2>1.兑换码是什么？</h2>
   <p>兑换码主要用来兑换畅学卡会员及部分课程等</p>
   <h2>2.兑换不了怎么办？</h2>
    <p>兑换不了可能是兑换码错误；兑换码已经失效；兑换码已被人兑换过了；</p>
    <h2>3.其他兑换码问题？</h2>
    <p>可在{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '微课系统'}}公众号进行咨询</p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.exchangeRule {
  padding: rem(30);
  line-height: 1.5;
  h1 {
    font-size: rem(38);
    font-weight: 900;
    margin-bottom: rem(30);
  }
  h2 {
    font-size: rem(32);
    font-weight: bold;
    margin-bottom: rem(20);

  }
  p {
    padding-left: rem(20);
    font-size: rem(30);
    margin-bottom: rem(20);

  }
}
</style>
